/*
 * @Description:
 * @Autor: tanglitong
 * @Date: 2021-01-26 13:22:09
 * @LastEditors: tanglitong
 * @LastEditTime: 2021-03-09 19:36:57
 */
import Fingerprint2 from 'fingerprintjs2'
import { Message, MessageBox } from 'element-ui'
import { singleDeviceCheck, singleDeviceSwitch } from '../api/api.js'

/**
 * @description: 存储浏览器指纹
 */
export const StorageFingerprint = () => {
  const FingerprintID = localStorage.getItem('FingerprintID')
  if (!FingerprintID) {
    Fingerprint2.get(function (components) {
      const values = components.map(function (component, index) {
        if (index === 0) {
          //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
          return component.value.replace(/\bNetType\/\w+\b/, '')
        }
        return component.value
      })
      // 生成最终id murmur
      const murmur = Fingerprint2.x64hash128(values.join(''), 31)
      localStorage.setItem('FingerprintID', murmur)
    })
  }
}

/**
 * @description: 关闭当前页面/关闭当前窗口
 */
const CloseWebPage = () => {
  if (navigator.userAgent.indexOf('MSIE') > 0) {
    if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
      window.opener = null
      window.close()
    } else {
      window.open('', '_top')
      window.top.close()
    }
  } else if (navigator.userAgent.indexOf('Firefox') > 0) {
    window.location.href = 'about:blank '
  } else {
    window.opener = null
    window.open('', '_self', '')
    window.close()
  }
}

/**
 * @description: 验证设备是否唯一
 * @param userid 用户id
 * @param loopTime 循环执行时间 s
 * @param that
 */
export const VerifyDeviceBinding = (userid, loopTime = 60, that) => {
  // 延迟执行下一次调用
  const Timeout = setTimeout(() => {
    clearTimeout(Timeout)
    VerifyDeviceBinding(userid, loopTime, that)
  }, loopTime * 1000)
  
  // 检测是否有网络
  if (navigator.onLine) {
    const params = {
      userId: userid,
      deviceId: localStorage.getItem('FingerprintID'),
      deviceName: 'PC',
      extraInfo: window.navigator.userAgent
    }
    singleDeviceCheck(params)
      .then((res) => {
        const data = res.data
        if (!data.data.checkResult) {
          //如果有视频实例则暂停视频播放
          if (that && that.plyrInstances[0]) {
            that.plyrInstances[0].pause()
          }
          MessageBox.confirm(data.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            showClose: false,
            closeOnClickModal: false,
            callback: (action) => {
              if (action === 'confirm') {
                DeviceSwitch(params, Timeout)
              } else if (action === 'cancel') {
                clearTimeout(Timeout)
                CloseWebPage()
              }
            }
          })
        }
      })
      .catch((err) => {
        MessageBox.alert(err.msg, '提示', {
          confirmButtonText: '确定',
          type: 'error',
          showClose: false,
          callback: (action) => {
            clearTimeout(Timeout)
            CloseWebPage()
          }
        })
      })
  } else {
    MessageBox.confirm('网络中断, 请保证网络畅通', '提示', {
      confirmButtonText: '退出',
      cancelButtonText: '重试',
      type: 'error',
      showClose: false,
      callback: (action) => {
        if (action === 'confirm') {
          clearTimeout(Timeout)
          CloseWebPage()
        } else if (action === 'cancel') {
          clearTimeout(Timeout)
          VerifyDeviceBinding(userid)
        }
      }
    })
  }
}

/**
 * @description: 切换设备
 */
const DeviceSwitch = (params, Timeout) => {
  singleDeviceSwitch(params)
    .then((res) => {
      const {code, data, msg} = res.data
      if (code !== 0) {
        Message({
          type: 'error',
          message: msg
        })
        clearTimeout(Timeout)
        CloseWebPage()
      }
      if (!data.checkResult) {
        Message({
          type: 'warning',
          message: msg
        })
        clearTimeout(Timeout)
        CloseWebPage()
      }
    })
    .catch(() => {
      clearTimeout(Timeout)
      CloseWebPage()
    })
}



// WEBPACK FOOTER //
// ./src/utils/fingerprint.js